// removed by extract-text-webpack-plugin
module.exports = {"header":"_1W0n9_1W"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Parcel/components/History/History.css
// module id = 771
// module chunks = 0